import {io, Socket} from 'socket.io-client'
import {
  ADMIN_TOKEN_NAME,
  BACKEND_URL,
  SOCKET_URL,
} from './constants/apiConstants'
import {getCookies} from './utils/cookiesUtil'

export let socket: Socket | null = null

export const initiateSocketConnection = (): void => {
  const token = getCookies(ADMIN_TOKEN_NAME)

  socket = io(SOCKET_URL || `${BACKEND_URL}/`, {
    path: `/socket.io`,
    forceNew: true,
    reconnectionAttempts: 3,
    timeout: 2000,
    transports: ['websocket'],
    auth: {token},
  })
}

export const disconnectSocket = (): void => {
  if (socket) {
    socket.disconnect()
    socket = null
  }
}

export const subscribeToSocket = (key: string, data: unknown): void => {
  if (!socket) return
  socket.emit(key, data)
}
